<script setup>
/* eslint-disable */
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { useMarketsStore } from '@/stores/markets';
import { useDateTimeSportFiltersStore } from '@/stores/date_time_sport_filters';
import { usePreSportsStore } from '@/stores/pre_sports';

import PreSportsHighlights from './PreSportsHighlights.vue'
import { useSportPopularStore } from '@/stores/sport_popular';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useLiveSportOverview } from '@/stores/live_sport_overview';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';
import { useRouter } from 'vue-router';
import { useLandingSportsStore } from '@/stores/landing_sports';

const marketsStore = useMarketsStore();
const preSportsStore = usePreSportsStore();
const datetimeSportFiltersStore = useDateTimeSportFiltersStore();
const direction = ref(document.dir);
const router = useRouter();
const liveSportOverviewStore = useLiveSportOverview();
const sportPopularStore = useSportPopularStore();
const active_tab = ref('live');
const selected_overview_market = ref(null)
const splideOptions = ref({
	direction: direction.value,
	pagination: false,
	arrows: false,
	autoWidth: true,
	trimSpace: 'move',
	gap: '1rem',
	breakpoints: {
		640: {
			gap: '1rem',
		},
	},
});

const props = defineProps({
	sport: {
		required: true
	},
	fixtures_count: {
		type: Number,
		default: 5
	}
})


let el = null;
const handleScroll = () => {
	if (!el) return

	if (window.scrollY >= 650) {
		el.classList.add('is-stuck')
	} else {
		el.classList.remove('is-stuck')
	}
}


onMounted(() => {
	let overview_markets = marketsStore.sportOverviewMarkets(props.sport.id);
	if (overview_markets?.length > 0) selected_overview_market.value = overview_markets[0];

	el = document.querySelector('.oupa');

	window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
	window.removeEventListener('scroll', handleScroll);
})
const goToSportHighlights = () => {
	//
	useLandingSportsStore().setSelectedSport(props.sport);
	useLandingSportsStore().setSelectedOverviewMarket(selected_overview_market.value);

	if (active_tab.value == 'live') {
		router.push({name: 'live-sports-overview'})
		return;
	}


	router.push({name: 'pre-sports-coupons-competitions-from-to', params: {sport_id: props.sport.id, from: 'today'}})
};

const changeTab = (tab) => {
	active_tab.value = tab;
}


const selectMarket = (overview_market) => {
	selected_overview_market.value = overview_market;
}

watch(() => props.sport, (newSport, oldSport) => {
	let overview_markets = marketsStore.sportOverviewMarkets(newSport.id);
	if (overview_markets?.length > 0) selected_overview_market.value = overview_markets[0];

}, {deep: true})

watch(() => liveSportOverviewStore.overviewFixturesCount, (newVal) => {
	if (active_tab.value == 'live' && newVal == 0) {
		active_tab.value = 'upcoming';
	}
});


</script>

<template>

	<div class="oupa">
		<div class="tabs">
			<button  v-if="liveSportOverviewStore.overviewFixturesCount > 0" class="tab" :class="active_tab == 'live' ? 'active' : ''"  @click="changeTab('live')">{{ $t('general.live') }} ({{ liveSportOverviewStore.overviewFixturesCount }})</button>
			<button class="tab" :class="active_tab == 'upcoming' ? 'active' : ''" @click="changeTab('upcoming')">{{$t('general.upcoming')}}</button>
			<button class="tab" :class="active_tab == 'popular' ? 'active' : ''" @click="changeTab('popular')">{{$t('general.popular')}}</button>
		</div>

		<div class="header-overview">
			<div class="overview-markets-container">
				<Splide :options="splideOptions">
					<SplideSlide v-for="market in marketsStore.sportOverviewMarkets(sport.id)" :key="market.id">
						<span class="market-name" :class="{ 'is-active': market.slug == selected_overview_market?.slug }" @click="selectMarket(market)">{{ market.name }}</span>
					</SplideSlide>
				</Splide>
			</div>

			<div class="view-all-desktop">
				<button @click="goToSportHighlights" class="view-all-btn">{{ $t('landing.view_all')}} </button>
			</div>
		</div>
	</div>
	<div class="sports-main">
		<div class="sports-center-content">
			<div class="live-bet-dashboard round-games-main set_game-outer">
				<PreSportsHighlights :sport="sport" :primary_overview_market="selected_overview_market" :active_tab="active_tab" :fixtures_count="fixtures_count"/>
			</div>
		</div>
	</div>

</template>
<style scoped>
:deep(.upcomimg_sport) {
		padding-right: 0px !important;
		padding-left: 0px !important;
    }

.tabs {
	height: 30px;
    margin-top: 5px;
  display: flex;
  /* background: #1f2a35; */
  border-bottom: 2px solid rgba(255,255,255,0.08);
}

.tab {
	margin: 0px;
  flex: 1;
  display: flex;              /* 👈 important */
  align-items: center;        /* vertical center */
  justify-content: center;    /* horizontal center */
  padding: 0px;

  background: none;
  border: none;
  color: var(--white);

  /* letter-spacing: 0.5px; */
  cursor: pointer;
  position: relative;
  transition: color 0.2s ease;
  text-align: center;         /* fallback */
	font-weight: 400;
	font-size: 13px;
}

.tab:hover {
  color: var(--white);
}

.tab.active {
  color: var(--white);
}

.tab.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--primary);
}

.header-overview {
	padding-left: 5px;
    padding-right: 5px;
	padding-top: 10px;
    display: grid;
	grid-template-columns: 79% 20%;
	grid-gap: 7px;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    color: var(--white);
}
.view-all-btn {
	height: 24px;
    width: 100%;
    background: var(--primary);
    color:var(--white);
    /* border: 1px solid var(--light-gray); */
    font-size: 12px;
    font-size: 12px;
    font-weight: 500;
	    border-radius: 7px;
    letter-spacing: 0.3px;
    cursor: pointer;
    transition: background-color 0.25s
ease, color 0.25s
ease, box-shadow 0.25s
ease, border-color 0.25s
ease;
}

/* Hover */
.view-all-btn:hover {
	background-color: rgba(255, 255, 255, 0.1);
	box-shadow: 0 0 10px rgba(255, 255, 255, 0.35);
	border-color: var(--white);
}

/* Active */
.view-all-btn:active {
	transform: scale(0.97);
}

/* Optional: focus for accessibility */
.view-all-btn:focus-visible {
	outline: none;
	box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.4);
}


:deep(.round-games-main .set_game-outer) {
	padding-left: 0px !important;
	padding-right: 0px !important;
}

.live-bet-dashboard {
	padding-left: 5px !important;
	padding-right: 5px !important;
}


.overview-markets-container{
	margin-top: 7px;
	border-bottom: 1px solid var(--tab-gray);
	position: sticky;
    position: sticky;
    top: 100px;
    z-index: 10;
	transition: top 0.2s ease;
}

.oupa.is-stuck {
	position: sticky;
	background: var(--dark);
	top: 50px;
    padding-top: 10px;
    /* height: 48px; */
	z-index: 10;
}

.oupa.is-stuck .header-overview{
	background: var(--dark);
}

.market-name {
	color: var(--white);
	font-size: 12px;
	cursor: pointer;
	display: inline-block;
	position: relative;
	transition: color 0.3s ease;
	white-space: nowrap;
}

.market-name.is-active {
	color: var(--white);
	font-weight: 600;
}

.market-name.is-active::after {
	content: "";
	position: absolute;
	bottom: -2px;
	left: 0;
	width: 100%;
	height: 3px;
	background-color: var(--primary);
	border-radius: 2px 2px 0 0;
}

:deep(.splide__arrow:disabled) {
	display: none !important;
}


html[dir="rtl"] .overview-markets-container :deep(.splide__arrows .splide__arrow--next) {
	rotate: 180deg;
	left: -10px;
	top: -15px;
	display: flex;
	right: unset;
}

@media screen and (min-width: 320px) and (max-width: 767px) {



	html[dir="rtl"] .overview-markets-container :deep(.splide__arrows .splide__arrow--next) {
		left: 0px;
	}

	html[dir="rtl"] .overview-markets-container :deep(.splide__arrows .splide__arrow--prev) {
		right: 0px
	}
}

@media screen and (min-width: 768px) and (max-width: 1280px) {
	html[dir="rtl"] .overview-markets-container :deep(.splide__arrows .splide__arrow--next) {
		left: 0px;
	}

	html[dir="rtl"] .overview-markets-container :deep(.splide__arrows .splide__arrow--prev) {
		right: 0px
	}
}


@media screen and (min-width: 320px) and (max-width: 767px) {
	:deep(.splide__arrows .splide__arrow--next) {
		right: 0px !important;
	}





}

@media screen and (min-width: 320px) and (max-width: 767px) {
	:deep(.splide__arrows .splide__arrow--prev) {
		left: 0px !important;
	}
}

</style>